import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import acc from 'accounting'
import initialData from "../../../../utilities/initialData/initialData";
import {
    TopButtonAction,
    TopButtonAdd,
    TopButtonPointAction,
    TopButtonPointEdit
} from "../../../../componentsTopsa/buttons/TopButtons";
import LSService from "../../../../utilities/localStorageService/LSService";
import {TopAlertSukces, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import PokazOdbicia from "./PokazOdbicia";

export default class StronaKlientaTabMiesieczne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            odbiciaId: null,
            showOdbicia: false,            statusy: [
                {value: 'NOWA', label: 'nowa'},
                {value: 'PRZYJETA', label: 'przyjeta'},
                {value: 'GOTOWA', label: 'gotowa'},
                {value: 'ZWROCONA', label: 'zwrócona'}
            ],
            miesiacetabela:{
                1: 'styczeń',
                2: 'luty',
                3: 'marzec',
                4: 'kwiecień',
                5: 'maj',
                6: 'czerwiec',
                7: 'lipiec',
                8: 'sierpień',
                9: 'wrzesień',
                10: 'październik',
                11: 'listopad',
                12: 'grudzień',
            }
        };
        this.formatStatus = this.formatStatus.bind(this)
        this.formatUwagi = this.formatUwagi.bind(this)
        this.expandComponent = this.expandComponent.bind(this)
        this.onClickEdytujKarte = this.onClickEdytujKarte.bind(this)
        this.renderButtonEdytuj = this.renderButtonEdytuj.bind(this)
        this.renderButtonDodaj = this.renderButtonDodaj.bind(this)
        this.renderButtonOdbicia = this.renderButtonOdbicia.bind(this)
        this.onClickDodajBiletMiesieczny = this.onClickDodajBiletMiesieczny.bind(this)
        this.onClickDodaj = this.onClickDodaj.bind(this)
    }

    renderOdcinek(cell,row){
        return (<div>
            <div>
                {row.nazTr}
            </div>
            <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic'}}>{row.nazMiOd} - {row.nazMiDo}</div>
        </div>)
    }

    renderKierunek(cell, row) {
        if (cell === 1) {
            // w jedna stronę
            return <div title={'Przejazd tylko w jednym kierunku'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-long-arrow-right'}></i>
            </div>
        }
        else if (cell === 2) {
            return <div title={'Przejazd w obydwa kierunki'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-exchange'}></i>
            </div>
        }
        else return cell
    }

    renderOkres(cell, row) {
        if (cell === 'P1') {
            return <div title={'Pierwsza połowa miesiąca'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-adjust'} style={{transform: 'rotate(180deg)'}}></i>
            </div>
        }
        else if (cell === 'P2') {
            return <div title={'Druga połowa miesiąca'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-adjust'}></i>
            </div>
        }
        else if (cell === 'M1') {
            return <div title={'Cały miesiąc'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-circle'}></i>
            </div>

        }
        else return cell
    }

    renderRodzaj(cell, row) {
        return (<span className={'label label-ebus-default'} style={{color:'#fff', background:row.kolor}} title={row.nazZniz}>{cell}</span>)
    }

    formatStatusKarty(cell, row) {
        return cell
    }

    formatIleBiletow(cell,row){
        if(Boolean(row.biletymiesieczne)) return row.biletymiesieczne.length
    }

    formatCenaBiletow(cell,row){
        if(Boolean(row.biletymiesieczne)){
            if(row.biletymiesieczne.length>0){
                let cena = 0;
                for(let i=0;i<row.biletymiesieczne.length;i++){
                    if(row.biletymiesieczne[i].kierunek==2){
                        cena = cena + (parseFloat(row.biletymiesieczne[i].cena)*2)
                    }else{
                        cena = cena + parseFloat(row.biletymiesieczne[i].cena)
                    }

                }

                return (<span>{acc.formatMoney(cena)}</span>)
            }
            else return '-'
        }
    }

    formatMiesiac(cell,row){
        if(Boolean(cell)){
            let msc = initialData.returnArrayMiesiace().find(m=>m.value===cell)
            if(Boolean(msc)) return msc.label
            else return cell
        }
    }

    formatTransakcje(cell,row){
        let tpay = row.platnoscTpay
        let tr = row.platnosciTransakcja

        return <div>{tr}{Boolean(tpay)?(', '+tpay):''}</div>
    }

    onClickEdytujKarte(karta){
        LSService.ustawKarteDoEdycji(karta)
        this.props.history.push('/konfiguracja/zarzadzanie-klientami/karty')
    }

    renderButtonDodaj(cell,row){
        return(<TopButtonPointAction onClick={()=>{this.onClickDodajBiletMiesieczny(row)}} buttonColor={'success'} buttonIcon={'fa fa-plus'} titleContent={'Dodaj bilet miesięczny na tą kartę'}/>)
    }

    renderButtonEdytuj(cell,row){
        return (<TopButtonPointEdit onClick={()=>this.onClickEdytujKarte(row)} titleContent={'Przejdź do widoku edycji karty'}/>)
    }

    renderButtonOdbicia(cell,row){
        return(<TopButtonPointAction onClick={()=>{this.onClickPokazOdbicia(row.idKa)}} buttonColor={'default'} buttonIcon={'fa fa-ticket'} titleContent={'Zobacz odbicia karty'}/>)
    }

    onClickDodajBiletMiesieczny(karta){
        LSService.ustawDaneKartyDoDodaniaMies(karta)
        this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny')
    }

    onClickPokazOdbicia(idKa){
        this.setState({odbiciaId: idKa, showOdbicia: true})
    }

    renderMiesiacRok(cell, row) {
        let msc = initialData.returnArrayMiesiace().find(m => m.value === row.miesiac)
        return (<div>
            <div>{row.rok + ', ' + msc.label}</div>
            <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic'}}>{row.waznyOd + ' - ' + row.waznyDo}</div>
        </div>)
    }

    formatUwagi(cell,row){
        if(Boolean(cell)){
            return (<i className={'fa fa-info-circle'} onClick={()=>{alert(cell)}}></i>)
        }
    }

    expandComponent(row) {

        let okresy = {
            "P1": "I połowa",
            "P2": "II połowa",
            "M1": "cały miesiąc",
        }

        let kierunki = {
            1: "jednostronny",
            2: "dwustronny"
        }

        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={{marginBottom: '5px'}}>
                <h3 style={{textAlign:'center'}}>
                    <span>
                    Historia zakupionych biletów na karcie numer <span className={'label label-ebus-primary'} style={{fontSize:'20px'}}>{row.nrKarty}</span> na trasę <span className={'label label-ebus-default'} style={{fontSize:'20px'}}>{row.nazTr}</span>
                    </span>
                    <div className={'pull-right'}>
                        <TopButtonAdd onClick={()=>this.onClickDodajBiletMiesieczny(row)} text={'Dodaj bilet miesięczny'} buttonSize={'sm'}/>
                    </div>
                </h3>
                <div>
                    <BootstrapTable data={row.biletymiesieczne}
                                    hover
                                    options={{noDataText: 'Brak pasujących rekordów'}}
                    >
                        <TableHeaderColumn dataField='idBm' dataSort isKey
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >ID biletu</TableHeaderColumn>
                        <TableHeaderColumn dataField='miesiac' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.renderMiesiacRok}
                                           filter={{type: 'SelectFilter', options: this.state.miesiacetabela, selectText: '', condition:'eq'}} formatExtraData={this.state.miesiacetabela}
                        >Miesiąc</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazTr' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.renderOdcinek}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Odcinek</TableHeaderColumn>
                        <TableHeaderColumn dataField='kierunek' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.renderKierunek}
                                           filter={{type: 'SelectFilter', options: kierunki, selectText: ''}} formatExtraData={kierunki}
                        >Kierunek</TableHeaderColumn>
                        <TableHeaderColumn dataField='okres' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.renderOkres}
                                           filter={{type: 'SelectFilter', options: okresy, selectText: ''}} formatExtraData={okresy}

                        >Okres</TableHeaderColumn>
                        <TableHeaderColumn dataField='rodz' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.renderRodzaj}
                        >Rodzaj</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>{if(row.kierunek==2){return acc.formatMoney((cell*2))} else {return acc.formatMoney(cell)}}}
                        >Cena</TableHeaderColumn>
                        <TableHeaderColumn dataField='status' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatStatus}
                                           filter={{type: 'SelectFilter', options: {"-1": "do opłaty",1:'opłacony'}, selectText: ''}} formatExtraData={{"-1": "do opłaty",1:'opłacony'}}
                        >Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='infoPlatnosci' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatTransakcje}
                        >Transakcje</TableHeaderColumn>
                        <TableHeaderColumn dataField='uwagi' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatUwagi}
                        >Uwagi</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-sm fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-sm fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        return (Boolean(row.biletymiesieczne))? row.biletymiesieczne.length>0 : false
    }

    onClickDodaj(klient){
        LSService.ustawDaneKlientaDoDodaniaKarty(Object.assign(klient,{imieNazwisko:klient.imie+' '+klient.nazwisko}))
        this.props.history.push('/konfiguracja/zarzadzanie-klientami/karty')
    }

    formatStatus(cell,row){

        if(row.status === null) return '?'
        if(cell == -2){
            return <div><i className={'fa fa-refresh'} style={{color:'grey'}}></i> zwrócony</div>
        }
        else if(cell == 1){
            return <div><i className={'fa fa-check'} style={{color:'forestgreen'}}></i> opłacony</div>
        }
        else{
            return <div><i className={'fa fa-times'} style={{color:'firebrick'}}></i> do opłaty</div>
        }
    }

    czyZablokowacPrzycisk(){
        let czyZablokowac = false
        if(Boolean(this.props.klient)){
            if(!this.props.klient.imie || !this.props.klient.nazwisko){
                czyZablokowac = true
            }
        }
        else czyZablokowac = true

        return czyZablokowac

    }

    render() {
        let okresy = {
            "P1": "I połowa",
            "P2": "II połowa",
            "M1": "cały miesiąc",
        }

        let kierunki = {
            1: "jednostronny",
            2: "dwustronny"
        }

        let statusy = {
            'NOWA': 'nowa',
            'PRZYJETA': 'przyjęta',
            'GOTOWA': 'gotowa',
            'ZWROCONA': 'zwrócona',
        }

        return (
            <div>
                {this.state.showOdbicia ?  <div id={'EBUSModalContainerBG'}>
                    <div id={'modalContainer'}>
                        <div id={'modalTextContent'} style={{width: '1000px'}}>
                            <div>
                                <div className={'pull-right'}>
                                    <TopButtonAction onClick={() => {
                                        this.setState({showOdbicia: false})
                                    }}
                                                     elementStyle={{color: 'firebrick'}}
                                                     btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                    />
                                </div>
                                <PokazOdbicia idKa={this.state.odbiciaId}/>
                            </div>
                        </div>
                        <div style={{clear: 'both'}}></div>
                    </div>
                </div> : null}
                <div className={'pull-right'}>
                    <TopIf isTrue={this.czyZablokowacPrzycisk()}>
                        <TopAlertUwaga text={'Przed dodaniem biletu należy uzupełnić dane klienta'} inline={true} /> {' '}
                    </TopIf>
                    <TopButtonAdd onClick={()=>this.onClickDodaj(this.props.klient)} buttonSize={'sm'} text={'Dodaj kartę'} disabled={this.czyZablokowacPrzycisk()}/>
                </div>
                <div style={{clear:'both', height:'1px'}}></div>
                <div>
                    <BootstrapTable data={this.props.miesieczne}
                                    hover
                                    options={{noDataText: 'Brak pasujących rekordów',expandBy: 'column'}}
                                    expandableRow={this.isExpandableRow}
                                    expandComponent={this.expandComponent}
                                    expandColumnOptions={{
                                        expandColumnVisible: true,
                                        expandColumnComponent: this.expandColumnComponent,
                                        columnWidth: 30,
                                    }}
                    >
                        <TableHeaderColumn dataField='idKa' isKey hidden={true}>Id karty</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrKarty' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Nr karty</TableHeaderColumn>
                        <TableHeaderColumn dataField='dataWydania' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={(cell,row)=>{return<span style={{fontSize:12}}>{cell}</span>}}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Data wydania</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazTr' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={ false }
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Trasa</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazMiOd' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={(cell,row)=>{return<span style={{fontSize:12}}>{cell}</span>}}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Od miejscowości</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazMiDo' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={(cell,row)=>{return<span style={{fontSize:12}}>{cell}</span>}}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Do miejscowości</TableHeaderColumn>
                        <TableHeaderColumn dataField='kierunek' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.renderKierunek}
                                           filter={{type: 'SelectFilter', options: kierunki, selectText: ''}} formatExtraData={kierunki}
                        >Kierunek</TableHeaderColumn>
                        <TableHeaderColumn dataField='okres' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.renderOkres}
                                           filter={{type: 'SelectFilter', options: okresy, selectText: ''}} formatExtraData={okresy}

                        >Okres</TableHeaderColumn>
                        <TableHeaderColumn dataField='rodz'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={ false }
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.renderRodzaj}
                        >Rodzaj</TableHeaderColumn>
                        <TableHeaderColumn dataField='status' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           filter={{type: 'SelectFilter', options: statusy, selectText: ''}} formatExtraData={statusy}
                                           dataFormat={this.formatStatusKarty}
                        >Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKa'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.formatIleBiletow}
                        >Ile biletów</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKa'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={ false }
                                           dataFormat={this.formatCenaBiletow}
                        >Suma wartości</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKa'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={ false }
                                           dataFormat={this.renderButtonOdbicia}
                        >Sprawdź odbicia</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKa'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={ false }
                                           dataFormat={this.renderButtonEdytuj}
                        >Edycja karty</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKa'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={ false }
                                           dataFormat={this.renderButtonDodaj}
                        >Dodaj miesięczny</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/stronaKlienta/components/StronaKlientaTabMiesieczne.js